export const NAMAVALI = {
    ganesha: {
        doc: '/chants/ganesha-ashtottara.json',
        title: 'Aṣṭādaśa Nāmāvaliḥ — the eighteen names of Gaṇapati',
    },
    lakshmi: {
        doc: '/chants/lakshmi-ashtottara.json',
        title: 'Śrī Lakṣmī Aṣṭottara Śatanāmāvalī',
    },
};
/** The registered garland for a deity, or null when none is published yet. */
export function namavaliFor(deity) {
    return (deity && NAMAVALI[deity]) || null;
}
